import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Wakadtomumbaicab() {



const cardData = {
  keyword: " Wakad to Mumbai Cabs  ",

headingDescription:
  "Velocity Cab provides reliable and comfortable Wakad to Mumbai cab services, ensuring a hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Wakad to Mumbai smooth and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Wakad to Mumbai cab travel.",

topPlaces: [
{
    title: "Kanheri Caves",
    description: "Kanheri Caves are ancient Buddhist rock-cut monuments located inside Sanjay Gandhi National Park. Visitors choosing an Innova Crysta on rent in Pune can comfortably reach this historic destination and explore centuries-old caves, sculptures, meditation halls, and lush green surroundings ideal for history lovers and adventure seekers."
  },
  {
    title: "Worli Sea Face",
    description: "Worli Sea Face is a beautiful waterfront promenade where visitors can enjoy cool sea breezes, scenic views, and spectacular sunsets. Renting an Innova Crysta in Pune ensures a comfortable road trip for families and groups looking to relax by Mumbai's coastline and capture memorable photographs."
  },
  {
    title: "Taraporewala Aquarium",
    description: "Taraporewala Aquarium is one of India's oldest aquariums, showcasing a fascinating variety of marine and freshwater species. Travelers hiring an Innova Crysta on rent in Pune can conveniently visit this family-friendly attraction, making it an enjoyable destination for children, students, and marine life enthusiasts."
  },
  {
    title: "Crawford Market",
    description: "Crawford Market is a historic shopping destination famous for fresh produce, spices, dry fruits, handicrafts, and imported goods. Booking an Innova Crysta on rent in Pune allows visitors to comfortably explore this vibrant marketplace while experiencing Mumbai's rich local culture and colonial architecture."
  },
    {
    title: "Mahalakshmi Temple",
    description: "Mahalakshmi Temple is one of Mumbai's oldest and most revered Hindu temples, attracting thousands of devotees throughout the year. Travelers booking an Innova Crysta on rent in Pune can enjoy a comfortable journey to this sacred destination while exploring its beautiful architecture, peaceful surroundings, and nearby coastal viewpoints. It is an excellent place for spiritual visits and cultural exploration."
  },
  {
    title: "Gilbert Hill",
    description: "Gilbert Hill is a rare volcanic rock formation estimated to be over 66 million years old. Visitors choosing an Innova Crysta on rent in Pune can comfortably explore this unique geological landmark and enjoy panoramic views of Mumbai from the hilltop temple. It is a hidden gem perfect for photography and sightseeing."
  },
  {
    title: "Gateway of India",
    description: "Gateway of India is Mumbai's most celebrated landmark, overlooking the Arabian Sea. Renting an Innova Crysta in Pune makes the road trip convenient for families and groups planning a memorable sightseeing experience. Visitors can admire the monument's architecture, enjoy ferry rides, and explore nearby heritage attractions in South Mumbai."
  },
  {
    title: "Phoenix Marketcity",
    description: "Phoenix Marketcity is one of Mumbai's premier shopping and entertainment destinations, featuring luxury brands, restaurants, gaming zones, and multiplex cinemas. Travelers hiring an Innova Crysta on rent in Pune can spend an enjoyable day shopping, dining, and relaxing with family and friends in this modern lifestyle destination."
  },
  {
    title: "Bandra Bandstand",
    description: "Bandra Bandstand is a scenic seaside promenade offering spectacular views of the Arabian Sea and the Bandra-Worli Sea Link. Travelers booking an Innova Crysta on rent in Pune can enjoy a relaxing drive before taking peaceful walks, visiting nearby cafés, and exploring one of Mumbai's most popular waterfront locations."
  },
  
  {
    title: "Marine Drive",
    description: "Marine Drive, popularly known as the Queen's Necklace, is one of Mumbai's most iconic coastal roads. Travelers choosing an Innova Crysta on rent in Pune can enjoy a scenic journey before relaxing along the promenade, watching the sunset over the Arabian Sea, and experiencing the lively atmosphere that makes Marine Drive a favorite among visitors."
  }
],



services: [
{
name: "Wakad to Mumbai Cab",
description: "Wakad to Mumbai cab service provides reliable transportation for travelers heading from Wakad in Pune to Mumbai city. Comfortable vehicles with experienced drivers ensure safe highway journeys via the Mumbai–Pune Expressway. Pickup services are available from homes, offices, hotels, and residential societies in Wakad. Ideal for business travel, tourism trips, and family visits. Flexible booking options allow easy cab reservations."
},
{
name: "Wakad to Mumbai Airport Cab",
description: "Wakad to Mumbai Airport cab service offers dependable airport transportation for passengers traveling from Wakad to Chhatrapati Shivaji Maharaj International Airport. Vehicles provide comfortable seating and sufficient luggage space for airport journeys. Professional drivers ensure punctual pickup and safe expressway travel. Pickup services are available across Wakad and nearby areas. Flexible booking options allow advance airport ride reservations."
},
{
name: "Wakad to Dadar Cab",
description: "Wakad to Dadar cab service provides convenient intercity transportation between Wakad and Dadar in Mumbai. Comfortable vehicles and professional drivers ensure safe and smooth expressway travel. Pickup services are available from homes, offices, and hotels across Wakad. Ideal for railway travelers, business trips, and tourism visits. Flexible booking options allow convenient ride reservations."
},
{
name: "Taxi Wakad to Mumbai International Airport",
description: "Taxi Wakad to Mumbai International Airport service offers reliable transportation for passengers traveling to Mumbai’s international airport terminal. Vehicles are well maintained and suitable for long-distance airport journeys with luggage space for travelers. Professional drivers ensure safe driving and timely arrival. Pickup services are available from homes, offices, and residential complexes across Wakad. Flexible booking options allow easy airport cab reservations."
},
{
name: "Wakad to Mumbai Domestic Airport Cab Fare",
description: "Wakad to Mumbai domestic airport cab fare services provide transparent pricing for travelers planning airport transfers from Wakad to Mumbai Airport. Passengers can choose vehicles based on budget and comfort requirements. Professional drivers ensure safe and punctual highway travel. Pickup services are available from homes and offices across Wakad. Flexible booking options allow convenient ride planning."
},
{
name: "Wakad to Mumbai Innova Taxi Fare",
description: "Wakad to Mumbai Innova taxi fare services provide pricing information for premium SUV travel between Wakad and Mumbai. Innova vehicles offer spacious seating and smooth ride quality suitable for long-distance highway journeys. Professional drivers ensure safe driving and punctual pickup services. Flexible booking options allow convenient SUV ride reservations."
},
{
name: "Wakad to Borivali Cab",
description: "Wakad to Borivali cab service offers dependable transportation between Wakad in Pune and Borivali in Mumbai. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys. Pickup services are available from homes, offices, and hotels in Wakad. Flexible booking options allow easy cab reservations."
},
{
name: "Wakad to Mumbai Ertiga Taxi",
description: "Wakad to Mumbai Ertiga taxi service offers spacious SUV transportation suitable for families and small groups traveling between Wakad and Mumbai. The Ertiga vehicle provides comfortable seating and luggage space suitable for highway journeys. Professional drivers ensure safe driving and punctual pickup services. Flexible booking options allow convenient SUV ride reservations."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides reliable airport transportation for travelers heading to Mumbai Airport terminals. Vehicles provide comfortable seating and luggage space suitable for airport transfers. Professional drivers ensure safe driving and punctual pickup services across Pune. Flexible booking options allow convenient airport ride reservations."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service offers spacious SUV transportation for passengers traveling between Pune and Mumbai. The Ertiga vehicle provides comfortable seating and luggage space suitable for expressway travel. Professional drivers ensure safe driving and punctual pickup services. Flexible booking options allow convenient SUV ride reservations."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service provides premium SUV transportation for comfortable long-distance travel. Innova vehicles offer spacious seating and smooth ride quality suitable for expressway journeys. Professional drivers ensure safe driving and punctual pickup services across Pune and Mumbai. Flexible booking options allow convenient ride reservations."
},
{
name: "Wakad to Mumbai Cab Booking Online",
description: "Wakad to Mumbai cab booking online service allows travelers to quickly reserve taxis for intercity travel through online platforms. Vehicles are comfortable and suitable for expressway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, and residential areas across Wakad. Flexible booking options allow convenient ride scheduling."
},
{
name: "Wakad to Mumbai Airport Cab Charges",
description: "Wakad to Mumbai Airport cab charges services provide transparent fare information for passengers traveling from Wakad to Mumbai Airport. Pricing varies depending on vehicle type such as sedan, Ertiga, or Innova. Professional drivers ensure safe and punctual airport transfers. Flexible booking options allow convenient travel planning."
},
{
name: "Wakad to Andheri Cab Charges",
description: "Wakad to Andheri cab service provides comfortable transportation between Wakad and Andheri in Mumbai. Vehicles are suitable for expressway travel with experienced drivers ensuring safe journeys. Pickup services are available from homes, offices, and hotels across Wakad. Flexible booking options allow easy cab reservations."
},
{
name: "Wakad to Navi Mumbai Cabs",
description: "Wakad to Navi Mumbai cab service offers reliable transportation between Wakad and Navi Mumbai city. Comfortable vehicles with professional drivers ensure safe highway journeys. Pickup services are available from homes, offices, and residential societies across Wakad. Flexible booking options allow convenient ride reservations."
},
{
name: "Wakad to Navi Mumbai Innova Crysta",
description: "Wakad to Navi Mumbai Innova Crysta cab service offers premium SUV transportation for passengers seeking luxury travel between Wakad and Navi Mumbai. The Innova Crysta provides spacious seating and smooth ride quality suitable for long-distance travel. Flexible booking options allow convenient luxury ride reservations."
},
{
name: "Cab Service in Wakad",
description: "Cab service in Wakad provides reliable transportation for local travel, airport transfers, and outstation journeys. Comfortable vehicles with professional drivers ensure safe and smooth rides across Wakad and nearby areas. Flexible booking options allow easy taxi reservations."
},
{
name: "Taxi Service in Wakad Pune",
description: "Taxi service in Wakad Pune offers dependable transportation for passengers traveling within Pune city and nearby destinations. Vehicles are comfortable and suitable for daily commuting, airport transfers, and intercity travel. Professional drivers ensure safe driving and punctual pickup services."
},
{
name: "Best Car Service in Wakad",
description: "Best car service in Wakad provides reliable and comfortable transportation for local and outstation travel. Vehicles are well maintained and suitable for family travel, corporate trips, and airport transfers. Professional drivers ensure safe driving and punctual pickup services. Flexible booking options allow convenient ride reservations."
},
{
name: "Pune Wakad Innova Crysta on Rent",
description: "Pune Wakad Innova Crysta on rent service offers premium SUV rental for travelers seeking luxury transportation. The Innova Crysta provides spacious seating and smooth ride quality suitable for long-distance travel. Professional drivers ensure safe driving and punctual pickup services across Wakad and Pune."
},
{
name: "Pune Mumbai Velocity Cabs",
description: "Pune Mumbai Velocity Cabs service offers dependable intercity transportation between Pune and Mumbai. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys. Flexible booking options allow convenient cab reservations."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides reliable transportation for local rides, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe travel across Pune and nearby destinations. Flexible booking options allow convenient taxi reservations."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab service offers dependable transportation between Pune and Mumbai via the expressway. Vehicles are comfortable and suitable for long-distance travel with experienced drivers ensuring safe journeys. Flexible booking options allow easy cab reservations."
},
{
name: "Best Cab Service in Wakad Pune",
description: "Best cab service in Wakad Pune provides reliable transportation for passengers traveling from Wakad to Mumbai, airport destinations, and nearby cities. Comfortable vehicles with experienced drivers ensure safe travel and punctual pickup services. Flexible booking options allow convenient cab reservations."
},
{
name: "Cab Service in Wakad",
description: "Cab service in Wakad offers dependable transportation for local rides, airport transfers, and outstation travel. Comfortable vehicles with professional drivers ensure safe and smooth journeys across Wakad and Pune city. Flexible booking options allow easy cab reservations."
},
{
name: "Wakad to Mumbai Cabs",
description: "Wakad to Mumbai cabs service provides reliable intercity transportation for passengers traveling between Wakad and Mumbai city. Vehicles are well maintained and suitable for expressway travel with experienced drivers ensuring safe journeys. Flexible booking options allow convenient ride reservations."
}
],

tableData: [
["Wakad to Mumbai Cab","Wakad to Mumbai Airport Cab"],
["Wakad to Dadar Cab","Taxi Wakad to Mumbai International Airport"],
["Wakad to Mumbai Domestic Airport Cab Fare","Wakad to Mumbai Innova Taxi Fare"],
["Wakad to Borivali Cab","Wakad to Mumbai Ertiga Taxi"],
["Pune to Mumbai Airport Cab","Pune to Mumbai Ertiga Cab"],
["Pune to Mumbai Innova Cab","Wakad to Mumbai Cab Booking Online"],
["Wakad to Mumbai Airport Cab Charges","Wakad to Andheri Cab Charges"],
["Wakad to Navi Mumbai Cabs","Wakad to Navi Mumbai Innova Crysta"],
["Cab Service in Wakad","Taxi Service in Wakad Pune"],
["Best Car Service in Wakad","Pune Wakad Innova Crysta on Rent"],
["Pune Mumbai Velocity Cabs","Cab Service in Pune"],
["Pune Mumbai Cab","Best Cab Service in Wakad Pune"],
["Cab Service in Wakad","Wakad to Mumbai Cabs"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who frequently travel from Wakad to Mumbai via the Mumbai Pune Expressway. Their familiarity with highway routes and traffic patterns ensures a safe, smooth, and timely journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Wakad to Mumbai cab services. Customers receive clear fare details including toll charges and driver allowance before confirming their booking."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Wakad to Mumbai cab service operates 24 hours a day. Whether you need an early morning airport transfer, corporate travel, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Wakad to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Wakad",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, and residential societies across Wakad and nearby areas like Hinjewadi, Tathawade, Pimple Saudagar, and Baner."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Wakad to Mumbai cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Wakad to Mumbai cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Wakad to Mumbai with professional drivers and comfortable vehicles." },
  { question: "Is Wakad to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Wakad to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Wakad to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services between Wakad and Mumbai." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and residential societies across Wakad." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Wakad to Mumbai cab services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides drop services to Mumbai Airport and all major locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "A smooth and comfortable journey from Wakad to Mumbai. The cab was punctual, clean, and the ride felt relaxed throughout the trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback:
      "The Wakad to Mumbai cab service was very reliable. The vehicle was well-maintained, the drive was steady, and the entire travel experience felt safe and hassle-free.",
    rating: 5
  }
];









































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wakad to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Wakad to Mumbai cab service with affordable fares and professional drivers. Book one way and round trip taxis including Ertiga, Innova, and Innova Crysta for airport transfers, Dadar, Andheri, Navi Mumbai, Borivali, and other destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Wakad to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};







  return (
    <div>
      <Helmet>
  <title>Wakad to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Wakad to Mumbai cab with Velocity Cabs. Affordable taxi service for one way, round trip & airport drop. Ertiga, Innova & Crysta cabs available for Dadar, Andheri, Borivali, Navi Mumbai & Mumbai airport." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/12.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Wakadtomumbaicab;